import { IUserManagement } from "../../pages/Admin/types";

export const formatOktaUserData = (values: IUserManagement) => ({
  email: values.email,
  firstName: values.first_name,
  lastName: values.last_name,
})
